import { mapResourceApi } from '@/api/mapResourceApi'
/**
 * 全局的字典配置
 */

const globalConfigDIC = {
  // 对应周边搜索字典表【T_DICFACILITY】
  facilityDic: []
}

mapResourceApi.selectDicFacility().then(res => {
  if (res.code === '200') {
    globalConfigDIC.facilityDic = res.data
  }
})

export default {
  globalConfigDIC
}

export {
  globalConfigDIC
}
